import { createFileRoute } from '@tanstack/react-router'
import { Brain } from 'lucide-react'
import { z } from 'zod'
import { MyMemoryScreen } from '@/screens/me/SCR-120-my-memory'

export const Route = createFileRoute('/_app/me/memory')({
  staticData: { screen: { id: 'SCR-120', title: 'My memory', group: 'Me', pin: true, order: 1, eyebrow: 'What ESM remembers about you', description: 'See every fact your agents can use about you, where it came from, and correct or forget it.', icon: Brain } },
  validateSearch: z.object({
    q: z.string().max(200).optional(),
    status: z.enum(['all', 'current', 'ended']).optional(),
    source: z.enum(['all', 'explicit', 'inferred']).optional(),
    m: z.string().max(200).optional(),
  }),
  component: MyMemoryScreen,
})
